const translations = {
  en: {
    adminDashboard: 'Admin Dashboard',
    groupeOuambo: 'Groupe Ouambo',
    password: 'Password',
    enterAdminPassword: 'Enter admin password',
    login: 'Login',
    backToWebsite: '← Back to website',
    overview: 'Overview',
    workers: 'Workers',
    projects: 'Projects',
    sell: 'All Sales',
    invoices: 'Invoices',
    quotesTitle: 'Quotes',
    invoicesTitle: 'Invoices',
    quotesTrack: 'Create, send and track client quotes.',
    invoicesTrack: 'Create, send and track invoices.',
    addNewQuote: 'New quote',
    addNewInvoice: 'New invoice',
    addQuote: 'Add quote',
    addInvoice: 'Add invoice',
    allQuotes: 'All quotes',
    allInvoices: 'All invoices',
    paid: 'Paid',
    training: 'Training',
    equipment: 'Equipment',
    liveChat: 'Live Chat',
    workerDashboard: 'Worker Dashboard →',
    logisticsDashboard: 'Logistics Dashboard →',
    publicSite: '← Public Site',
    logout: 'Logout',
    admin: 'Admin',
    dashboardOverview: 'Dashboard Overview',
    welcomeBack: "Welcome back! Here's what's happening at Groupe Ouambo.",
    activeWorkers: 'Active Workers',
    activeProjects: 'Active Projects',
    totalSales: 'Total Sales',
    chatMessages: 'Chat Messages',
    total: 'total',
    unread: 'unread',
    records: 'records',
    manageProjects: 'Manage Projects →',
    manageSales: 'Manage Sales →',
    recentSales: 'Recent Sales',
    workerManagement: 'Worker Management',
    addAndManageTeam: 'Add and manage all team members across departments.',
    addNewWorker: 'Add New Worker',
    fullName: 'Full Name',
    rolePosition: 'Role / Position',
    department: 'Department',
    region: 'Region',
    email: 'Email',
    phone: 'Phone',
    dashboardPassword: 'Dashboard Password',
    workerLoginPassword: 'Worker login password',
    addWorker: 'Add Worker',
    departmentSummary: 'Department Summary',
    allWorkers: 'All Workers',
    search: 'Search...',
    name: 'Name',
    role: 'Role',
    contact: 'Contact',
    status: 'Status',
    actions: 'Actions',
    edit: 'Edit',
    remove: 'Remove',
    editWorker: 'Edit Worker',
    cancel: 'Cancel',
    saveChanges: 'Save Changes',
    noWorkers: 'No workers yet.',
    noResults: 'No results.',
    projectManagement: 'Project Management',
    createProjects: 'Create projects, assign managers, and track progress.',
    createNewProject: 'Create New Project',
    projectTitle: 'Project Title',
    rubricCategory: 'Rubric / Category',
    startDate: 'Start Date',
    dueDate: 'Due Date',
    assignToWorker: 'Assign to Worker',
    selectWorker: '— Select worker —',
    initialStatus: 'Initial Status',
    description: 'Description',
    createProject: 'Create Project',
    noProjects: 'No projects yet.',
    backToProjects: '← Back to Projects',
    projectInfo: 'Project Info',
    rubric: 'Rubric',
    assignedTo: 'Assigned to',
    start: 'Start',
    due: 'Due',
    progressUpdates: 'Progress Updates',
    noUpdatesYet: 'No updates yet.',
    commentsSection: 'Comments',
    noComments: 'No comments yet. Start the conversation.',
    writeAComment: 'Write a comment...',
    postComment: 'Post Comment',
    salesManagement: 'Sales Management',
    trackSales: 'Track quotes, orders and sales records.',
    quotes: 'Quotes',
    confirmed: 'Confirmed',
    delivered: 'Delivered',
    totalRevenue: 'Total Revenue',
    addNewSale: 'Add New Sale / Quote',
    client: 'Client',
    productService: 'Product / Service',
    amount: 'Amount',
    date: 'Date',
    notes: 'Notes',
    addSale: 'Add Sale',
    allSales: 'All Sales',
    searchSales: 'Search client, product...',
    trainingPrograms: 'Training Programs',
    createAndManage: 'Create and manage training courses.',
    addNewCourse: 'Add New Course',
    courseTitle: 'Course Title',
    duration: 'Duration',
    category: 'Category',
    addCourse: 'Add Course',
    noCourses: 'No courses yet.',
    equipmentManagement: 'Equipment Management',
    addManageEquipment: 'Add and manage IT equipment listings.',
    addNewEquipment: 'Add New Equipment',
    title: 'Title',
    price: 'Price',
    addEquipment: 'Add Equipment',
    noEquipment: 'No equipment uploaded yet.',
    liveChatTitle: 'Live Chat',
    respondCustomers: 'Respond to customer inquiries in real-time.',
    clearChat: '🗑 Clear Chat',
    noMessages: 'No messages yet.',
    typeReply: 'Type your reply...',
    sendReply: 'Send Reply',
    youAdmin: 'You (Admin)',
    visitor: 'Visitor',
    message: 'message',
    messages: 'messages',
    viewUpdates: 'View Updates →',
    tracking: 'Worker Tracking',
    schedule: 'Schedule & Leave',
    policy: 'Policy',
    safety: 'Safety',
  },
  fr: {
    adminDashboard: 'Tableau de bord Admin',
    groupeOuambo: 'Groupe Ouambo',
    password: 'Mot de passe',
    enterAdminPassword: 'Entrez le mot de passe admin',
    login: 'Se connecter',
    backToWebsite: '← Retour au site',
    overview: 'Aperçu',
    workers: 'Employés',
    projects: 'Projets',
    sell: 'Toutes les ventes',
    invoices: 'Factures',
    quotesTitle: 'Devis',
    invoicesTitle: 'Factures',
    quotesTrack: 'Créez, envoyez et suivez les devis clients.',
    invoicesTrack: 'Créez, envoyez et suivez les factures.',
    addNewQuote: 'Nouveau devis',
    addNewInvoice: 'Nouvelle facture',
    addQuote: 'Ajouter le devis',
    addInvoice: 'Ajouter la facture',
    allQuotes: 'Tous les devis',
    allInvoices: 'Toutes les factures',
    paid: 'Payées',
    training: 'Formation',
    equipment: 'Équipement',
    liveChat: 'Chat en direct',
    workerDashboard: 'Tableau de bord Employé →',
    logisticsDashboard: 'Tableau de bord Logistique →',
    publicSite: '← Site public',
    logout: 'Déconnexion',
    admin: 'Admin',
    dashboardOverview: 'Tableau de bord',
    welcomeBack: 'Bienvenue ! Voici ce qui se passe chez Groupe Ouambo.',
    activeWorkers: 'Employés actifs',
    activeProjects: 'Projets actifs',
    totalSales: 'Total des ventes',
    chatMessages: 'Messages chat',
    total: 'total',
    unread: 'non lus',
    records: 'entrées',
    manageProjects: 'Gérer les projets →',
    manageSales: 'Gérer les ventes →',
    recentSales: 'Ventes récentes',
    workerManagement: 'Gestion des employés',
    addAndManageTeam: 'Ajoutez et gérez tous les membres de l\'équipe.',
    addNewWorker: 'Ajouter un employé',
    fullName: 'Nom complet',
    rolePosition: 'Rôle / Poste',
    department: 'Département',
    region: 'Région',
    email: 'Email',
    phone: 'Téléphone',
    dashboardPassword: 'Mot de passe du tableau de bord',
    workerLoginPassword: 'Mot de passe de connexion de l\'employé',
    addWorker: 'Ajouter un employé',
    departmentSummary: 'Résumé par département',
    allWorkers: 'Tous les employés',
    search: 'Rechercher...',
    name: 'Nom',
    role: 'Rôle',
    contact: 'Contact',
    status: 'Statut',
    actions: 'Actions',
    edit: 'Modifier',
    remove: 'Supprimer',
    editWorker: 'Modifier l\'employé',
    cancel: 'Annuler',
    saveChanges: 'Enregistrer',
    noWorkers: 'Aucun employé pour l\'instant.',
    noResults: 'Aucun résultat.',
    projectManagement: 'Gestion de projets',
    createProjects: 'Créez des projets, assignez des responsables et suivez la progression.',
    createNewProject: 'Créer un nouveau projet',
    projectTitle: 'Titre du projet',
    rubricCategory: 'Rubrique / Catégorie',
    startDate: 'Date de début',
    dueDate: 'Date d\'échéance',
    assignToWorker: 'Assigner à un employé',
    selectWorker: '— Sélectionner un employé —',
    initialStatus: 'Statut initial',
    description: 'Description',
    createProject: 'Créer le projet',
    noProjects: 'Aucun projet pour l\'instant.',
    backToProjects: '← Retour aux projets',
    projectInfo: 'Infos du projet',
    rubric: 'Rubrique',
    assignedTo: 'Assigné à',
    start: 'Début',
    due: 'Échéance',
    progressUpdates: 'Mises à jour',
    noUpdatesYet: 'Aucune mise à jour pour l\'instant.',
    commentsSection: 'Commentaires',
    noComments: 'Pas encore de commentaires. Commencez la conversation.',
    writeAComment: 'Écrire un commentaire...',
    postComment: 'Publier un commentaire',
    salesManagement: 'Gestion des ventes',
    trackSales: 'Suivez les devis, commandes et ventes.',
    quotes: 'Devis',
    confirmed: 'Confirmées',
    delivered: 'Livrées',
    totalRevenue: 'Chiffre d\'affaires',
    addNewSale: 'Ajouter une vente / devis',
    client: 'Client',
    productService: 'Produit / Service',
    amount: 'Montant',
    date: 'Date',
    notes: 'Notes',
    addSale: 'Ajouter la vente',
    allSales: 'Toutes les ventes',
    searchSales: 'Rechercher client, produit...',
    trainingPrograms: 'Programmes de formation',
    createAndManage: 'Créez et gérez les cours de formation.',
    addNewCourse: 'Ajouter un cours',
    courseTitle: 'Titre du cours',
    duration: 'Durée',
    category: 'Catégorie',
    addCourse: 'Ajouter le cours',
    noCourses: 'Aucun cours pour l\'instant.',
    equipmentManagement: 'Gestion de l\'équipement',
    addManageEquipment: 'Ajoutez et gérez les équipements informatiques.',
    addNewEquipment: 'Ajouter un équipement',
    title: 'Titre',
    price: 'Prix',
    addEquipment: 'Ajouter l\'équipement',
    noEquipment: 'Aucun équipement ajouté pour l\'instant.',
    liveChatTitle: 'Chat en direct',
    respondCustomers: 'Répondez aux demandes des clients en temps réel.',
    clearChat: '🗑 Effacer le chat',
    noMessages: 'Aucun message pour l\'instant.',
    typeReply: 'Tapez votre réponse...',
    sendReply: 'Envoyer',
    youAdmin: 'Vous (Admin)',
    visitor: 'Visiteur',
    message: 'message',
    messages: 'messages',
    viewUpdates: 'Voir les mises à jour →',
    tracking: 'Suivi des Employés',
    schedule: 'Planning & Congés',
    policy: 'Politique',
    safety: 'Sécurité',
  }
}

export default translations
